export default [
  {
    title: 'Dashboard',
    route: 'dashboard',
    icon: 'GridIcon',
  },
  {
    title: 'HR',
    route: 'hr',
    icon: 'ServerIcon',
    permission: 'employee-inquiry' || 'employee-create' || 'employee-detail' || 'employee-update' || 'employee-delete' || 'employee-export' || 'employee-import' || 'employee-image-store' || 'employee-address-create' || 'employee-address-update' || 'employee-bank-create' || 'employee-bank-update' || 'employee-tax-create' || 'employee-tax-update' || 'attendance-inquiry' || 'attendance-detail' || 'attendance-check-in-out' || 'attendance-add-manual' || 'attendance-update' || 'attendance-approval' || 'attendance-statistic' || 'attendance-export' || 'overtime-inquiry' || 'overtime-detail' || 'overtime-create' || 'overtime-update' || 'overtime-approval' || 'overtime-statistic' || 'overtime-export' || 'permit-inquiry' || 'permit-detail' || 'permit-create' || 'permit-update' || 'permit-approval' || 'permit-statistic' || 'permit-export' || 'reimbursement-inquiry' || 'reimbursement-detail' || 'reimbursement-create' || 'reimbursement-update' || 'reimbursement-approval' || 'reimbursement-statistic' || 'reimbursement-export' || 'cash-advance-inquiry' || 'cash-advance-detail' || 'cash-advance-create' || 'cash-advance-return' || 'cash-advance-update' || 'cash-advance-approval' || 'cash-advance-statistic' || 'cash-advance-export' || 'payroll-item-create' || 'payroll-item-detail' || 'payroll-item-update' || 'payroll-item-delete' || 'payroll-inquiry' || 'payroll-create' || 'payroll-detail' || 'payroll-update' || 'payroll-delete',
    children: [
      {
        title: 'Employees',
        route: 'employees',
        icon: 'ArrowRightIcon',
        permission: 'employee-inquiry' || 'employee-create' || 'employee-detail' || 'employee-update' || 'employee-delete' || 'employee-export' || 'employee-import' || 'employee-image-store' || 'employee-address-create' || 'employee-address-update' || 'employee-bank-create' || 'employee-bank-update' || 'employee-tax-create' || 'employee-tax-update',
      },
      {
        title: 'Attendances',
        route: 'attendances',
        icon: 'ArrowRightIcon',
        permission: 'attendance-inquiry' || 'attendance-detail' || 'attendance-check-in-out' || 'attendance-add-manual' || 'attendance-update' || 'attendance-approval' || 'attendance-statistic' || 'attendance-export',
      },
      {
        title: 'Overtimes',
        route: 'overtimes',
        icon: 'ArrowRightIcon',
        permission: 'overtime-inquiry' || 'overtime-detail' || 'overtime-create' || 'overtime-update' || 'overtime-approval' || 'overtime-statistic' || 'overtime-export',
      },
      {
        title: 'Permits',
        route: 'permits',
        icon: 'ArrowRightIcon',
        permission: 'permit-inquiry' || 'permit-detail' || 'permit-create' || 'permit-update' || 'permit-approval' || 'permit-statistic' || 'permit-export',
      },
      {
        title: 'Permit Quota',
        route: 'permit-quota',
        icon: 'ArrowRightIcon',
      },
      {
        title: 'Reimbursements',
        route: 'reimbursements',
        icon: 'ArrowRightIcon',
        permission: 'reimbursement-inquiry' || 'reimbursement-detail' || 'reimbursement-create' || 'reimbursement-update' || 'reimbursement-approval' || 'reimbursement-statistic' || 'reimbursement-export',
      },
      {
        title: 'Cash Advance',
        route: 'cash-advance',
        icon: 'ArrowRightIcon',
        permission: 'cash-advance-inquiry' || 'cash-advance-detail' || 'cash-advance-create' || 'cash-advance-return' || 'cash-advance-update' || 'cash-advance-approval' || 'cash-advance-statistic' || 'cash-advance-export',
      },
      {
        title: 'Payrolls',
        route: 'payrolls',
        icon: 'ArrowRightIcon',
        permission: 'payroll-item-create' || 'payroll-item-detail' || 'payroll-item-update' || 'payroll-item-delete' || 'payroll-inquiry' || 'payroll-create' || 'payroll-detail' || 'payroll-update' || 'payroll-delete',
      },
    ],
  },
  {
    title: 'Procurement',
    route: 'procurement',
    icon: 'TruckIcon',
    permission: 'vendor-category-inquiry' || 'vendor-category-create' || 'vendor-category-detail' || 'vendor-category-update' || 'vendor-category-delete' || 'vendor-inquiry' || 'vendor-create' || 'vendor-detail' || 'vendor-update' || 'vendor-delete' || 'procurement-purchase-inquiry' || 'procurement-purchase-create' || 'procurement-purchase-detail' || 'procurement-purchase-update' || 'procurement-purchase-delete' || 'procurement-purchase-item-inquiry' || 'procurement-purchase-item-create' || 'procurement-purchase-item-detail' || 'procurement-purchase-item-update' || 'procurement-purchase-item-delete' || 'procurement-receiving-inquiry' || 'procurement-receiving-create' || 'procurement-receiving-detail' || 'procurement-receiving-update' || 'procurement-receiving-delete',
    children: [
      {
        title: 'Vendor Category',
        route: 'vendor-category',
        icon: 'ArrowRightIcon',
        permission: 'vendor-category-inquiry' || 'vendor-category-create' || 'vendor-category-detail' || 'vendor-category-update' || 'vendor-category-delete',
      },
      {
        title: 'Vendor',
        route: 'vendor',
        icon: 'ArrowRightIcon',
        permission: 'vendor-inquiry' || 'vendor-create' || 'vendor-detail' || 'vendor-update' || 'vendor-delete',
      },
      {
        title: 'Purchase',
        route: 'purchase',
        icon: 'ArrowRightIcon',
        permission: 'procurement-purchase-inquiry' || 'procurement-purchase-create' || 'procurement-purchase-detail' || 'procurement-purchase-update' || 'procurement-purchase-delete' || 'procurement-purchase-item-inquiry' || 'procurement-purchase-item-create' || 'procurement-purchase-item-detail' || 'procurement-purchase-item-update' || 'procurement-purchase-item-delete',
      },
      {
        title: 'Receiving',
        route: 'receiving',
        icon: 'ArrowRightIcon',
        permission: 'procurement-receiving-inquiry' || 'procurement-receiving-create' || 'procurement-receiving-detail' || 'procurement-receiving-update' || 'procurement-receiving-delete',
      },
      {
        title: 'Payment',
        route: 'procurement-payment',
        icon: 'ArrowRightIcon',
        permission: ''
      },
      {
        title: 'Return',
        route: 'procurement-return',
        icon: 'ArrowRightIcon',
        permission: ''
      },
    ],
  },
  {
    title: 'Sales',
    route: 'sales',
    icon: 'UsersIcon',
    permission: 'sales-customer-category-inquiry' || 'sales-customer-category-create' || 'sales-customer-category-detail' || 'sales-customer-category-update' || 'sales-customer-category-delete' || 'sales-customer-inquiry' || 'sales-customer-create' || 'sales-customer-detail' || 'sales-customer-update' || 'sales-customer-delete' || 'sales-quotation-item-inquiry' || 'sales-quotation-item-create' || 'sales-quotation-item-detail' || 'sales-quotation-item-update' || 'sales-quotation-item-delete' || 'sales-quotation-inquiry' || 'sales-quotation-create' || 'sales-quotation-detail' || 'sales-quotation-update' || 'sales-quotation-delete' || 'sales-order-item-inquiry' || 'sales-order-item-create' || 'sales-order-item-detail' || 'sales-order-item-update' || 'sales-order-item-delete' || 'sales-order-inquiry' || 'sales-order-create' || 'sales-order-detail' || 'sales-order-update' || 'sales-order-delete' || 'sales-order-approval' || 'sales-address-inquiry' || 'sales-address-create' || 'sales-address-detail' || 'sales-address-delete' || 'sales-catalog-inquiry' || 'sales-catalog-create' || 'sales-catalog-detail' || 'sales-catalog-update' || 'sales-catalog-delete' || 'sales-borrow-inquiry' || 'sales-borrow-create' || 'sales-borrow-detail' || 'sales-borrow-update' || 'sales-borrow-delete' || 'sales-borrow-cancel' || 'sales-borrow-received' || 'sales-borrow-confirm-return' || 'sales-borrow-item-inquiry' || 'sales-borrow-item-create' || 'sales-borrow-item-detail' || 'sales-borrow-item-update' || 'sales-task-inquiry' || 'sales-task-create' || 'sales-task-detail' || 'sales-task-update' || 'sales-task-delete' || 'sales-target-inquiry' || 'sales-target-create' || 'sales-target-detail' || 'sales-target-update' || 'sales-target-delete',
    children: [
      {
        title: 'Customer Category',
        route: 'customer-category',
        icon: 'ArrowRightIcon',
        permission: 'sales-customer-category-inquiry' || 'sales-customer-category-create' || 'sales-customer-category-detail' || 'sales-customer-category-update' || 'sales-customer-category-delete',
      },
      {
        title: 'Customer',
        route: 'customer',
        icon: 'ArrowRightIcon',
        permission: 'sales-customer-inquiry' || 'sales-customer-create' || 'sales-customer-detail' || 'sales-customer-update' || 'sales-customer-delete',
      },
      {
        title: 'Quotation',
        route: 'quotation',
        icon: 'ArrowRightIcon',
        permission: 'sales-quotation-item-inquiry' || 'sales-quotation-item-create' || 'sales-quotation-item-detail' || 'sales-quotation-item-update' || 'sales-quotation-item-delete' || 'sales-quotation-inquiry' || 'sales-quotation-create' || 'sales-quotation-detail' || 'sales-quotation-update' || 'sales-quotation-delete',
      },
      {
        title: 'Order',
        route: 'order',
        icon: 'ArrowRightIcon',
        permission: 'sales-order-item-inquiry' || 'sales-order-item-create' || 'sales-order-item-detail' || 'sales-order-item-update' || 'sales-order-item-delete' || 'sales-order-inquiry' || 'sales-order-create' || 'sales-order-detail' || 'sales-order-update' || 'sales-order-delete' || 'sales-order-approval' || 'sales-address-inquiry' || 'sales-address-create' || 'sales-address-detail' || 'sales-address-delete',
      },
      {
        title: 'Catalog',
        route: 'catalog',
        icon: 'ArrowRightIcon',
        permission: 'sales-catalog-inquiry' || 'sales-catalog-create' || 'sales-catalog-detail' || 'sales-catalog-update' || 'sales-catalog-delete',
      },
      {
        title: 'Borrow Request',
        route: 'sales-borrow-request',
        icon: 'ArrowRightIcon',
        permission: 'sales-borrow-inquiry' || 'sales-borrow-create' || 'sales-borrow-detail' || 'sales-borrow-update' || 'sales-borrow-delete' || 'sales-borrow-cancel' || 'sales-borrow-received' || 'sales-borrow-confirm-return' || 'sales-borrow-item-inquiry' || 'sales-borrow-item-create' || 'sales-borrow-item-detail' || 'sales-borrow-item-update',
      },
      {
        title: 'Task',
        route: 'task',
        icon: 'ArrowRightIcon',
        permission: 'sales-task-inquiry' || 'sales-task-create' || 'sales-task-detail' || 'sales-task-update' || 'sales-task-delete',
      },
      {
        title: 'Target',
        route: 'target',
        icon: 'ArrowRightIcon',
        permission: 'sales-target-inquiry' || 'sales-target-create' || 'sales-target-detail' || 'sales-target-update' || 'sales-target-delete',
      },
    ],
  },
  {
    title: 'Product',
    route: 'product',
    icon: 'PackageIcon',
    permission: 'product-unit-inquiry' || 'product-unit-create' || 'product-unit-detail' || 'product-unit-update' || 'product-unit-delete' || 'product-category-inquiry' || 'product-category-create' || 'product-category-detail' || 'product-category-update' || 'product-category-delete' || 'product-inquiry' || 'product-create' || 'product-detail' || 'product-update' || 'product-delete',
    children: [
      {
        title: 'Units',
        route: 'units',
        icon: 'ArrowRightIcon',
        permission: 'product-unit-inquiry' || 'product-unit-create' || 'product-unit-detail' || 'product-unit-update' || 'product-unit-delete',
      },
      {
        title: 'Categories',
        route: 'categories',
        icon: 'ArrowRightIcon',
        permission: 'product-category-inquiry' || 'product-category-create' || 'product-category-detail' || 'product-category-update' || 'product-category-delete',
      },
      {
        title: 'Products',
        route: 'products',
        icon: 'ArrowRightIcon',
        permission: 'product-inquiry' || 'product-create' || 'product-detail' || 'product-update' || 'product-delete',
      },
    ],
  },
  {
    title: 'Warehouse',
    route: 'warehouse',
    icon: 'ArchiveIcon',
    permission: 'warehouse-inquiry' || 'warehouse-create' || 'warehouse-detail' || 'warehouse-update' || 'warehouse-delete' || 'warehouse-bin-inquiry' || 'warehouse-bin-detail' || 'warehouse-bin-create' || 'warehouse-bin-update' || 'warehouse-bin-delete' || 'warehouse-item-inquiry' || 'warehouse-item-create' || 'warehouse-item-update' || 'warehouse-item-detail' || 'warehouse-item-insert' || 'warehouse-fulfillment-inquiry' || 'warehouse-fulfillment-create' || 'warehouse-fulfillment-detail' || 'warehouse-fulfillment-update' || 'warehouse-fulfillment-delete' || 'warehouse-fulfillment-approval' || 'warehouse-fulfillment-item-inquiry' || 'warehouse-fulfillment-item-create' || 'warehouse-fulfillment-item-detail' || 'warehouse-fulfillment-item-update' || 'warehouse-fulfillment-item-delete' || 'warehouse-shipping-inquiry' || 'warehouse-shipping-detail' || 'warehouse-shipping-assign' || 'warehouse-shipping-confirm' || 'warehouse-shipping-reject' || 'warehouse-shipping-finish' || 'warehouse-receiving-inquiry' || 'warehouse-receiving-detail' || 'warehouse-receiving-update' || 'warehouse-transfer-inquiry' || 'warehouse-transfer-create' || 'warehouse-transfer-detail' || 'warehouse-transfer-update' || 'warehouse-transfer-confirm' || 'warehouse-transfer-reject' || 'warehouse-transfer-item-inquiry' || 'warehouse-transfer-item-create' || 'warehouse-transfer-item-detail' || 'warehouse-transfer-item-update' || 'warehouse-transfer-item-delete' || 'warehouse-replenishment-inquiry' || 'warehouse-replenishment-create' || 'warehouse-replenishment-detail' || 'warehouse-replenishment-update' || 'warehouse-replenishment-delete' || 'warehouse-borrow-inquiry' || 'warehouse-borrow-detail' || 'warehouse-borrow-approval' || 'warehouse-borrow-item-inquiry' || 'warehouse-borrow-item-detail' || 'warehouse-stockopname-inquiry' || 'warehouse-stockopname-create' || 'warehouse-stockopname-detail' || 'warehouse-stockopname-update' || 'warehouse-stockopname-confirm' || 'warehouse-stockopname-reject' || 'warehouse-stockopname-delete' || 'warehouse-stockopname-item-inquiry' || 'warehouse-stockopname-item-update' || 'warehouse-stockopname-item-show',
    children: [
      {
        title: 'Warehouse Location',
        route: 'warehouse-location',
        icon: 'ArrowRightIcon',
        permission: 'warehouse-inquiry' || 'warehouse-create' || 'warehouse-detail' || 'warehouse-update' || 'warehouse-delete',
      },
      {
        title: 'Bin Location',
        route: 'bin-location',
        icon: 'ArrowRightIcon',
        permission: 'warehouse-bin-inquiry' || 'warehouse-bin-detail' || 'warehouse-bin-create' || 'warehouse-bin-update' || 'warehouse-bin-delete',
      },
      {
        title: 'Item',
        route: 'item',
        icon: 'ArrowRightIcon',
        permission: 'warehouse-item-inquiry' || 'warehouse-item-create' || 'warehouse-item-update' || 'warehouse-item-detail' || 'warehouse-item-insert',
      },
      {
        title: 'Receiving',
        route: 'warehouse-receiving',
        icon: 'ArrowRightIcon',
        permission: 'warehouse-receiving-inquiry' || 'warehouse-receiving-detail' || 'warehouse-receiving-update',
      },
      {
        title: 'Transfer',
        route: 'transfer',
        icon: 'ArrowRightIcon',
        permission: 'warehouse-transfer-inquiry' || 'warehouse-transfer-create' || 'warehouse-transfer-detail' || 'warehouse-transfer-update' || 'warehouse-transfer-confirm' || 'warehouse-transfer-reject' || 'warehouse-transfer-item-inquiry' || 'warehouse-transfer-item-create' || 'warehouse-transfer-item-detail' || 'warehouse-transfer-item-update' || 'warehouse-transfer-item-delete',
      },
      {
        title: 'Replenishment',
        route: 'replenishment',
        icon: 'ArrowRightIcon',
        permission: 'warehouse-replenishment-inquiry' || 'warehouse-replenishment-create' || 'warehouse-replenishment-detail' || 'warehouse-replenishment-update' || 'warehouse-replenishment-delete',
      },
      {
        title: 'Stock Opname',
        route: 'stock-opname',
        icon: 'ArrowRightIcon',
        permission: 'warehouse-stockopname-inquiry' || 'warehouse-stockopname-create' || 'warehouse-stockopname-detail' || 'warehouse-stockopname-update' || 'warehouse-stockopname-confirm' || 'warehouse-stockopname-reject' || 'warehouse-stockopname-delete' || 'warehouse-stockopname-item-inquiry' || 'warehouse-stockopname-item-update' || 'warehouse-stockopname-item-show',
      },
      {
        title: 'Fulfillment Request',
        route: 'fulfillment-request',
        icon: 'ArrowRightIcon',
        permission: 'warehouse-fulfillment-inquiry' || 'warehouse-fulfillment-create' || 'warehouse-fulfillment-detail' || 'warehouse-fulfillment-update' || 'warehouse-fulfillment-delete' || 'warehouse-fulfillment-approval' || 'warehouse-fulfillment-item-inquiry' || 'warehouse-fulfillment-item-create' || 'warehouse-fulfillment-item-detail' || 'warehouse-fulfillment-item-update' || 'warehouse-fulfillment-item-delete',
      },
      {
        title: 'Shipping',
        route: 'shipping',
        icon: 'ArrowRightIcon',
        permission: 'warehouse-shipping-inquiry' || 'warehouse-shipping-detail' || 'warehouse-shipping-assign' || 'warehouse-shipping-confirm' || 'warehouse-shipping-reject' || 'warehouse-shipping-finish',
      },
      {
        title: 'Borrow Request',
        route: 'borrow-request',
        icon: 'ArrowRightIcon',
        permission: 'warehouse-borrow-inquiry' || 'warehouse-borrow-detail' || 'warehouse-borrow-approval' || 'warehouse-borrow-item-inquiry' || 'warehouse-borrow-item-detail',
      },
    ],
  },
  {
    title: 'Asset',
    route: 'asset',
    icon: 'LayersIcon',
    permission: 'asset-category-inquiry' || 'asset-category-create' || 'asset-category-detail' || 'asset-category-update' || 'asset-category-delete' || 'asset-location-inquiry' || 'asset-location-create' || 'asset-location-detail' || 'asset-location-update' || 'asset-location-delete' || 'asset-item-inquiry' || 'asset-item-create' || 'asset-item-detail' || 'asset-item-update' || 'asset-item-delete',
    children: [
      {
        title: 'Categories',
        route: 'asset-category',
        icon: 'ArrowRightIcon',
        permission: 'asset-category-inquiry' || 'asset-category-create' || 'asset-category-detail' || 'asset-category-update' || 'asset-category-delete',
      },
      {
        title: 'Locations',
        route: 'asset-locations',
        icon: 'ArrowRightIcon',
        permission: 'asset-location-inquiry' || 'asset-location-create' || 'asset-location-detail' || 'asset-location-update' || 'asset-location-delete',
      },
      {
        title: 'Items',
        route: 'asset-item',
        icon: 'ArrowRightIcon',
        permission: 'asset-item-inquiry' || 'asset-item-create' || 'asset-item-detail' || 'asset-item-update' || 'asset-item-delete',
      },
      {
        title: 'Movement',
        route: 'asset-movement',
        icon: 'ArrowRightIcon',
        permission: 'asset-movement-inquiry' || 'asset-movement-create' || 'asset-movement-detail' || 'asset-movement-update' || 'asset-movement-delete',
      },
      {
        title: 'Maintenance',
        route: 'asset-maintenance',
        icon: 'ArrowRightIcon',
        permission: 'asset-maintenance-inquiry' || 'asset-maintenance-create' || 'asset-maintenance-detail' || 'asset-maintenance-update' || 'asset-maintenance-delete',
      },
    ],
  },
  {
    title: 'Finance',
    route: 'finance',
    icon: 'BookIcon',
    permission: '',
    children: [
      {
        title: 'Account Type',
        route: 'account-type',
        icon: 'ArrowRightIcon',
        permission: ''
      },
      {
        title: 'Accounts',
        route: 'accounts',
        icon: 'ArrowRightIcon',
        permission: ''
      },
      {
        title: 'Payable',
        route: 'payable',
        icon: 'ArrowRightIcon',
        permission: ''
      },
      {
        title: 'Receivable',
        route: 'receivable',
        icon: 'ArrowRightIcon',
        permission: ''
      },
      {
        title: 'Transfer',
        route: 'finance-transfer',
        icon: 'ArrowRightIcon',
        permission: ''
      },
    ],
  },
  {
    title: 'User',
    route: 'user',
    icon: 'UserIcon',
    permission: 'role-inquiry' || 'role-create' || 'role-detail' || 'role-update' || 'role-delete' || 'role-permission',
    children: [
      {
        title: 'Roles',
        route: 'roles',
        icon: 'ArrowRightIcon',
        permission: 'role-inquiry' || 'role-create' || 'role-detail' || 'role-update' || 'role-delete' || 'role-permission',
      },
    ],
  },
  {
    title: 'Company',
    route: 'company',
    icon: 'CommandIcon',
    permission: 'company-update-create' || 'company-detail',
  },
  {
    title: 'Master',
    route: 'master',
    icon: 'FileTextIcon',
    permission: 'position-inquiry' || 'position-create' || 'position-detail' || 'position-update' || 'position-delete' || 'organization-inquiry' || 'organization-create' || 'organization-detail' || 'organization-update' || 'organization-delete' || 'division-inquiry' || 'division-create' || 'division-detail' || 'division-update' || 'division-delete' || 'department-inquiry' || 'department-create' || 'department-detail' || 'department-update' || 'department-delete' || 'master-status-inquiry' || 'master-status-create' || 'master-status-detail' || 'master-status-update' || 'master-status-delete' || 'master-ptkp-inquiry' || 'master-ptkp-create' || 'master-ptkp-detail' || 'master-ptkp-update' || 'master-ptkp-delete' || 'master-currency-inquiry' || 'master-currency-create' || 'master-currency-detail' || 'master-currency-update' || 'master-currency-delete' || 'master-payment-type-inquiry' || 'master-payment-type-create' || 'master-payment-type-detail' || 'master-payment-type-update' || 'master-payment-type-delete' || 'warehouse-shipping-type-inquiry' || 'warehouse-shipping-type-create' || 'warehouse-shipping-type-detail' || 'warehouse-shipping-type-update' || 'warehouse-shipping-type-delete',
    children: [
      {
        title: 'Organizations',
        route: 'organizations',
        icon: 'ArrowRightIcon',
        permission: 'organization-inquiry' || 'organization-create' || 'organization-detail' || 'organization-update' || 'organization-delete',
      },
      {
        title: 'Divisions',
        route: 'divisions',
        icon: 'ArrowRightIcon',
        permission: 'division-inquiry' || 'division-create' || 'division-detail' || 'division-update' || 'division-delete',
      },
      {
        title: 'Departments',
        route: 'departments',
        icon: 'ArrowRightIcon',
        permission: 'department-inquiry' || 'department-create' || 'department-detail' || 'department-update' || 'department-delete',
      },
      {
        title: 'Job Positions',
        route: 'jobs',
        icon: 'ArrowRightIcon',
        permission: 'position-inquiry' || 'position-create' || 'position-detail' || 'position-update' || 'position-delete',
      },
      {
        title: 'Employee Status',
        route: 'employee-status',
        icon: 'ArrowRightIcon',
        permission: 'master-status-inquiry' || 'master-status-create' || 'master-status-detail' || 'master-status-update' || 'master-status-delete',
      },
      {
        title: 'Employee PTKP',
        route: 'employee-ptkp',
        icon: 'ArrowRightIcon',
        permission: 'master-ptkp-inquiry' || 'master-ptkp-create' || 'master-ptkp-detail' || 'master-ptkp-update' || 'master-ptkp-delete',
      },
      {
        title: 'Currency',
        route: 'currency',
        icon: 'ArrowRightIcon',
        permission: 'master-currency-inquiry' || 'master-currency-create' || 'master-currency-detail' || 'master-currency-update' || 'master-currency-delete',
      },
      {
        title: 'Payment Type',
        route: 'payment-type',
        icon: 'ArrowRightIcon',
        permission: 'master-payment-type-inquiry' || 'master-payment-type-create' || 'master-payment-type-detail' || 'master-payment-type-update' || 'master-payment-type-delete',
      },
      {
        title: 'Shipping Type',
        route: 'shipping-type',
        icon: 'ArrowRightIcon',
        permission: 'warehouse-shipping-type-inquiry' || 'warehouse-shipping-type-create' || 'warehouse-shipping-type-detail' || 'warehouse-shipping-type-update' || 'warehouse-shipping-type-delete',
      },
    ],
  },
]